import { differenceInCalendarDays, parseISO } from 'date-fns';

export const getDaysCreated = (webSiteCreatedDate?: Date | null): number => {
  if (!webSiteCreatedDate) {
    return 0;
  }
  const formatted = new Date(webSiteCreatedDate).toISOString();
  const days_created = differenceInCalendarDays(new Date(Date.now()), parseISO(formatted));
  return days_created;
};

export const getDaysLeft = (weddingDate?: string | null): number => {
  if (!weddingDate) {
    return 0;
  }
  return Math.ceil((Date.parse(weddingDate) - Date.now()) / 86400000);
};

export const getCountDown = (weddingDate: string, hideWeddingDate?: boolean | null): string => {
  if (hideWeddingDate) {
    return '';
  }

  const daysLeft = getDaysLeft(weddingDate);

  if (daysLeft < 0) {
    return '';
  }

  return ` | ${daysLeft} Days To Go!`;
};
